export default "__VITE_ASSET__DNm4Z0s3__"